import { environment } from "src/environments/environment"

export class urls {
    static SERVER_URL = environment.baseUrl
    static API_URL = environment.baseUrl + 'api/v1/' 
    static SQUARE_APPICATION_ID=environment.SQUARE_APPLICATION_ID
    static SQUARE_LOCATION_ID=environment.SQUARE_LOCATION_ID
    static SQUARE_DEVELOPER_URL=environment.SQUARE_DEVELOPER_URL  
    // User
    static SIGNIN_URL = 'auth/login'
    static FORGOT_URL = 'auth/forgot'
    static PROFILE_URL = 'auth/me'
    static REFRESH_TOKEN = "auth/refresh-tokens"
    static CHANGE_PASSWORD_URL = 'users/password'
    static CHANGE_PROFILE_IMAGE = 'users/picture'
    // Staff
    static STAFF_URL = 'staffs'
    static STAFF_CREATE_URL = 'staffs/create'
    // Driver
    static DRIVERS_URL = 'drivers/companies'
    // static ADD_DRIVER_URL = 'drivers'
    static DRIVER_RESET_PASSWORD_URL = 'drivers/resetpassword'
    // Company
    static GET_COMPANIES = 'companies'
    static DISPATCH_CENTER_HISTOR_URL = 'dispatches/company'
    // Trips
    static ASSIGN_TRIPS = 'trips'
    static ASSIGN_EVENTS = 'events'
    static OPERATION_TRIPS = 'trips/operations'
    static STANDING_ORDER = 'standing-orders'
    static PARSE_TRIPS = 'trips/parse'
    static SINGLE_TRIP = 'assigns/singletrip'
    static ASSIGN_COMPANY = 'trips/status-update'
    // Notification
    static NOTIFICATIONS_URL = 'notifications'
    static NOTIFICATIONS_UNREAD_COUNT = 'notifications/unread-count'
    static NOTIFICATIONS_UNREAD_COUNT_URL = 'notifications/unread-count'
    static NOTIFICATIONS_MARK_ALL_READ = 'notifications/mark-all-read'
    static PUSH_PUBLIC_KEY = 'notifications/push/public-key'
    static PUSH_SUBSCRIBE = 'notifications/push/subscribe'
    static PUSH_UNSUBSCRIBE = 'notifications/push/unsubscribe'
    static PUSH_STATUS = 'notifications/push/status'
    static PUSH_TEST = 'notifications/push/test'
    // Funding Source
    static FUNDING_SOURCE_LIST = 'cooperates'
    static DOCUMENTS = 'documents'
    static MEMBER_UPLOAD = 'members/upload'
    static SPACETYPES = 'space-types'
    static LEVELOFSERVICE = 'level-of-service'
    static PICKER = '/picker'
    static COMPANIES = 'companies'
    static SIGNUPS = 'signup'
    static CREDENTIAL_COMPANIES = 'credentials-companies'
    static All_DRIVERS = 'drivers'
    static COMPANY_DRIVERS = 'drivers/company'
    static CREDENTIAL_VEHICLES = 'credentials-vehicles'
    static VEHICLES = 'vehicles'
    static COMPANY_VEHICLES = 'vehicles/company'
    // Fares
    static FARES = 'fares'
    static COMPANY_FARRES = 'fares/company'
    static FUNDING_SOURCE_FARRES = 'fares/fundingsource'
    static THRESHOLD = 'thresholds'
    // users
    static ADD_USERS = 'auth/register'
    static USERS = 'users'
    static ROLES = 'roles'
    static MEMBERS = 'members'
    static PERMISSIONS = 'roles/permissions'
    static FORGET_PASSWORD = 'auth/forgot-password'
    static RESET_PASSWORD = 'auth/reset-password'
    static APPOINTMENT_TYPES = 'appointment-types'
    static ADDONS = 'addons'
    static TRIP_ATTACHMENT = 'upload'
    static DASHBOARD = 'dashboard'
    static SERVICE_AREAS = 'service-areas'
    static FUNDING_SOURCES = 'fundingsources'
    static SEARCH_MEMBERS = 'members/search'
    static STATISTICS = 'trips/lean-kpis'
    static CHANGE_REASON = 'change-reasons'
    static PLACE_TYPES = 'place-types'
    static FARE_ESTIMATION = 'fare-estimation'
    static UPDATE_PENDING_TRIP_STATUS = 'pending-status-update'
    static PAYMENTS = 'payments'
    static PAYMENT_METHODS = 'payments/methods'
    static TRANSATIONS = 'transactions'
    static CHARGE_PAYMENT = 'payments/trips'
    static TUTORIALS = 'academy'
    static ADJUST_BILLING_TRIPS = 'fundingsource-billings'
    static FS_RAW_REPORT = 'fundingsource-billings/report'
    static MANUAL_PAYMENTS = 'manual-payments'
    static SUPPORT = 'support'

}